<template>
	<b-container fluid class="d-flex flex-column mh-100 h-100 no-gutters py-0 w-100 overflow-auto">
		<!-- OVERLAY pour affichage des erreurs principales -->
		<b-overlay :show="localErrors.main != null" opacity="0.6">
			<template #overlay>
				<div class="text-center">
					<b-badge variant="warning-light" class="text-warning-dark p-2 text-center">
						{{ localErrors.main }}
					</b-badge>
				</div>
			</template>
			<!-- ZONE DE PARAMETRAGE DE LA FEATURE -->
			<b-row v-if="(configs && configs.Data && configs.Pins.length > 0) || (configs && Preview)" class="w-100 no-gutters py-0">
				<!-- Section paramétrage date de début -->
				<b-card class="p-2 w-100 bg-white" body-class="d-flex flex-column p-0 my-0 border rounded shadow-sm">
					<!-- Overlay pour affichage des erreurs liées aux dates -->
					<b-overlay :show="localErrors.years != null" rounded="lg" opacity="0.6" spinner-small>
						<template #overlay>
							<div class="text-center">
								<b-badge variant="warning-light" class="text-warning-dark p-2 text-center">
									{{ localErrors.years }}
								</b-badge>
							</div>
						</template>
						<!-- Sélection du mode de période -->
						<b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100 bg-white">
							<b-row align-v="center" class="px-0">
								<b-col cols="auto">
									<small class="pl-0 pr-3 font-weight-bold">{{ $t('Period') }}</small>
								</b-col>
							</b-row>
						</b-card-header>
						<b-card-body class="py-0 bg-white">
							<b-row class="py-0">
								<b-form-select @change="setAllValues()" v-model="configs.Period" :options="simplePeriods" :label="$t('Start')" size="sm"
								class="m-1" text-field="Label" value-field="Extras">
									<template #first>
										<b-form-select-option :value="null" disabled>-- {{ $t('PleaseSelectYear') }} --</b-form-select-option>
									</template>
								</b-form-select>
								<!-- APPLICATION DE L'ANNEE GLISSANTE POUR PRISE EN COMPTE DE LA PROCEDURE STOCKEE -->
								<b-form-checkbox v-model="configs.Data.SlidingYear" class="m-1">{{ $t('LastSlidingYear') }}</b-form-checkbox>
							</b-row>
						</b-card-body>
					</b-overlay>
				</b-card>
				<b-row class="w-100 no-gutters py-0">
					<!-- Section paramétrage facteur d'influence -->
					<b-card class="p-2 w-100 bg-white" body-class="d-flex flex-column p-0 my-0 border rounded shadow-sm ">
						<!-- Overlay pour affichage erreurs liées aux facteurs d'influences -->
						<b-overlay :show="localErrors.factors != null" rounded="lg" opacity="0.6" spinner-small>
							<template #overlay>
								<div class="text-center">
									<b-badge variant="warning-light" class="text-warning-dark p-2 text-center">
										{{ localErrors.factors }}
									</b-badge>
								</div>
							</template>
							<b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100 bg-white">
								<b-row align-v="center" class="px-0">
									<b-col cols="auto">
										<small class="pl-0 pr-3 font-weight-bold">{{ $t('DataN', { n : configs.Data.Id }) }}</small> <!--  Donnée {{ configs.Data.Id }} --> 
									</b-col>
								</b-row>
							</b-card-header>
							<b-card-body class="position-relative py-1">
								<b-row class="py-0">
									<b-form-select :label="$tc('Factors', 1)" size="sm" class="m-1" v-model="configs.Data.FactorId" :options="factorList"
										@input="setArea($event)"
										value-field="Id"
										text-field="Label">
										<template #first>
											<b-form-select-option :value="0" disabled>-- {{ $t('PleaseSelectAFactor')}} --</b-form-select-option>
										</template>
									</b-form-select>
									<!-- INPUT NOMBRE QUI SE MET A JOUR LORS DE LA SELECTION DU FACTEUR D'INFLUENCE OU MODIFICATION MANUELLE POSSIBLE-->
									<b-input-group v-if="!Preview" :prepend="$t('Surface')" append="m²" size="sm" class="m-1">
										<b-form-input v-model="configs.Data.Area" size="sm"></b-form-input>
									</b-input-group>
								</b-row>
							</b-card-body>
						</b-overlay>
					</b-card>
				</b-row>
				<b-row class="w-100 no-gutters py-0">
					<!-- Section paramétrage des compteurs -->
					<b-card class="p-2 w-100 bg-white" body-class="d-flex flex-column p-0 my-0 border rounded shadow-sm">
						<!-- Overlay pour affichage des erreurs liées aux compteurs -->
						<b-overlay :show="localErrors.meters != null && configs.Period" rounded="lg" opacity="0.6" spinner-small>
							<template #overlay>
								<div class="text-center">
									<b-badge variant="warning-light" class="text-warning-dark p-2 text-center">
										{{ localErrors.meters }}
									</b-badge>
								</div>
							</template>
							<b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100 bg-white">
								<b-row align-v="center" class="px-0">
									<b-col cols="auto">
										<small class="pl-0 pr-3 font-weight-bold">{{ $tc('Meter', 2)}}</small> <!--  Compteurs -->
									</b-col>
								</b-row>
							</b-card-header>
							<b-card-body v-if="meters.length > 0 && configs.Period" class="position-relative py-1">
								<b-col class="d-flex justify-content-end p-0">
									<b-col>
										<b-form-group
											class="d-flex justify-content-start align-items-center"
											:label="$t('NumberDiffMeters')"
											label-for="MeterNumber"
      										label-cols-lg="8"
      										content-cols-lg="4">
											<b-input-group id="MeterNumber" size="sm">
												<b-form-select v-model="configs.Data.MeterNumber" :options="meterNumberList"></b-form-select>
												<b-input-group-append is-text>
													{{ '/ ' + meterNumberList.at(-1) }}
												</b-input-group-append>
											</b-input-group>
										</b-form-group>
									</b-col>
								</b-col>
								<b-card v-for="(meter, index) in meters" :key="index"
									class="p-2 w-100 bg-white"
									body-class="d-flex flex-column p-0 my-0 border rounded shadow-sm">
									<b-card-header header-tag="header" :header-bg-variant="Variant + '-light'" class="d-flex justify-content-between p-1 font-weight-bold w-100">
										<b-col class="p-0 d-flex align-items-center">
											<b-img :src="AbsoluteLink('Icons/' + meter.ObjectType + '_Icon.svg')" height="18rem" width="18rem" class="mx-1"/>
											{{ meter.Name }}
										</b-col>
										<b-button
											@click="toggleValues(meter)"
											size="sm"
											:variant="configs.Data.Values.hasOwnProperty(meter.PersistentId) && configs.Data.Values[meter.PersistentId].length > 0 ? 'outline-danger' : 'outline-' + Variant"
											class="border-0">
											<b-iconstack  v-if="configs.Data.Values.hasOwnProperty(meter.PersistentId) && configs.Data.Values[meter.PersistentId].length > 0">
												<b-icon stacked icon="check2-all" variant="danger"></b-icon>
												<b-icon stacked icon="slash-circle" variant="danger" scale="1.25" rotate="90"></b-icon>
											</b-iconstack>
											<b-icon-check2-all v-else></b-icon-check2-all>
										</b-button>
									</b-card-header>
									<!-- Section paramétrage des dates des compteurs -->
									<b-card-body>
										<b-form-checkbox-group v-if="setMeterYear(meter).length > 0" v-model="configs.Data.Values[meter.PersistentId]"
											class="d-flex flex-wrap justify-content-center">
											<b-form-checkbox
												v-for="(year, index) in setMeterYear(meter)"
												:key="index"
												@input="setMeterNumber()"
												:value="year">
													{{ year }}
													<b-icon-info-circle v-if="yearState(meter.Years, year)"
													v-b-tooltip.hover :title="$t('IncompleteYearData', {year: year})"
													variant="danger"/> <!-- 'Données de l\'année ' + year + ' incomplète' -->
											</b-form-checkbox>
										</b-form-checkbox-group>
										<b-alert v-else show class="p-0" variant="warning text-center">{{ $t('NoYearsAvailable') }}</b-alert>
									</b-card-body>
								</b-card>
							</b-card-body>
							<!-- Message pour informer l'utilisateur que la sélection des compteurs n'est pas applicable dans la partie administration des widgets -->
							<b-alert v-else-if="Preview" show variant="warning" class="text-center p-1 m-1">{{ $t('NoMeterSettingInPreview') }}</b-alert> <!-- Pas de paramétrage des compteurs en mode pré-visualisation -->
							<!-- Message d'erreur affiché lorsque l'utilsateur n'a pas encore sélectionné de date de début -->
							<b-alert v-else show variant="warning" class="text-center p-1 m-1">{{ $t('PleaseSelectAPeriod') }}</b-alert> <!-- Veuillez sélectionner une période -->
						</b-overlay>
					</b-card>
				</b-row>
			</b-row>
			<!-- Message d'information que le paramétrage ce fait lorsqu'un noeud est sélectionné -->
			<b-alert v-else show variant="warning" class="text-center p-1 m-1">{{ $t('PleaseSelectANode') }}</b-alert>
		</b-overlay>
    </b-container>
</template>

<script lang="ts">
	/** Composants VUE */
	import { Component, InjectReactive, Watch, Vue} from 'vue-property-decorator';
    import { mixins } from 'vue-class-component';
	/** Composant utilitaire */
	import { LinkUtils } from '@/components/commons/Utils';
	/** Composants de feature et utilitaire pour OfficialLabels */
	import OfficialLabelsUtils from '../OfficialLabelsUtils';
	import FeatureConfig from './FeatureConfig';
	/** Classes */
	import Dictionary from '@/types/Dictionary';
	/** Traductions */
	import locales from './locales/OfficialLabels.json';

	/** Paramétrage de la fonction Indicateur énergétique */
	@Component({
		i18n : { messages : locales }
	})
	export default class OfficialLabels extends mixins(FeatureConfig, LinkUtils, OfficialLabelsUtils) {
		
		//#region Attributs

		/** Boolean de prévisualisation */
		@InjectReactive()
		protected Preview!: boolean;

		/** Type objet sélectionné dans l'administration des widgets */
		@InjectReactive()
        protected ObjectType!: string;

		/** Liste des facteurs d'influence de surface */
		private factorList: { Id: string, Label: string, Value: number }[] = [];
        /** Liste des années des compteurs */
        private yearList: number[] = [];
        /** Liste des compteurs associés au noeud */
        private meters = [];
		/** Erreurs retournés lors de la prise d'information du noeud */
		private localErrors: Dictionary<any> = {};
		/** Titre de l'étiquette */
		private title: string = "";
		/** Liste pour définir la liste total de compteur utilisé pour le résultat final */
		private meterNumberList: number[] = [];
		/** Boolean pour le toggle des compteurs */
		private toggle: boolean = false;
		/** Liste des periodes du mode objectDashboard */
		private simplePeriods: { Id: string, Label: string, Extras: Dictionary<any> }[] = [
			{ Id: 'Year_5', Label: this.$t('LastYears5').toString() /*'5 dernières années'*/, Extras: { Mode: "Simple", Type: "Sliding", Duration: 5, TimeUnit: "Year", Periodicity: "Year", Compare: false } },
			{ Id: 'Year_3', Label: this.$t('LastYears3').toString() /*'3 dernières années'*/, Extras: { Mode: "Simple", Type: "Sliding", Duration: 3, TimeUnit: "Year", Periodicity: "Year", Compare: false } },
			{ Id: 'Year_2', Label: this.$t('LastYears2').toString() /*'2 dernières années'*/, Extras: { Mode: "Simple", Type: "Sliding", Duration: 2, TimeUnit: "Year", Periodicity: "Year", Compare: false } },
		]

		//#endregion

		//#region Méthodes privées

		/** Ajoute ou enleve de la liste le compteur */
		private setValues(meter, toggle: boolean = true){
			let years: number[] = [];
			
			if(toggle){
				this.yearList.forEach(year => {
					if(year >= this.configs.Period.Start && year <= this.configs.Period.End){
						years.push(year);
					}
				});
			} else {
				Vue.set(this.configs.Data.Values, meter.PersistentId, []);
			}
			this.toggle = !this.toggle;
			Vue.set(this.configs.Data.Values, meter.PersistentId, years);
			this.setMeterNumber();
		}

		/**
		 * Toggle de sélection des années du compteur
		 * @param meter Compteur
		 */
		private toggleValues(meter){
			this.setValues(meter, this.toggle);
		}

		/** Lors d'un changement de période 
		 * sélectionne l'ensemble des années des compteurs
		 */
		private setAllValues(){
			this.meters.forEach(meter => {
				this.setValues(meter)
			})
		}

		/** Relève le nombre de compteur à compter */
		private setMeterNumber(){
			let counter: number = 0;
			this.meters.forEach(meter => {
				if(this.configs.Data.Values.hasOwnProperty(meter.PersistentId) &&  this.configs.Data.Values[meter.PersistentId].length > 0)
					counter++
			})

			this.configs.Data.MeterNumber = counter;
			this.$forceUpdate()
		}

		/** Définie la liste des années du compteur */
		private setMeterYear(meter){
			let list: number[] = [];
			for(var i = this.configs.Period.Start; i <= this.configs.Period.End; i++){
				if(meter.Years[i] != null)
					list.push(i);
			}

			return list;
		}

		/** Vérification si l'année du compteur présente des données
		 * @param meterYears Liste des années sélectionnée pour un compteur
		 * @param year Année
		*/
		private yearState(meterYears: Dictionary<any>, year: number): boolean{
			return meterYears[year] == undefined || meterYears[year] == false
		}

        /** Attribut une valeur à area lorsque l'on sélectionne un facteur
		 * @param factorId Id du facteur à aller chercher dans la liste des facteurs afin d'en ressortir sa valeur
		 * */
        private setArea(factorId: string){
			if(!this.Preview){
				let value = this.factorList.find(factor => factor.Id == factorId).Value
            	this.configs.Data.Area = value;
			}
        }

		/** INITIALISATION DES PARAMETREES ET DES LISTES D'OPTIONS
		 * @param data Données du noeud / type objet retournées par le serveur
		*/
		private initParameters(data){
			if(data){
				this.meterNumberList = []; // Initialisation de la liste de compteurs différents
				/** LISTE DES FACTEURS D'INFLUENCE */
				if("Factors" in data){
					this.factorList = data["Factors"];
					this.configs.Data.FactorId = this.configs.Data.FactorId != 0 ? this.configs.Data.FactorId : this.factorList[0].Id;
				}
				/** LISTE DES ANNEES */
				if("YearList" in data){
					this.yearList = data["YearList"];
					let tempList: any[] = []
					this.yearList.forEach(year => {
						tempList.push({
							Id: year.toString(),
							Label: year.toString() + " / " + (year + 1).toString() + " / " + (year + 2).toString(),
							Extras: {
								Mode: "Simple",
								Type: "Range",
								Start: year.toString(),
								End : (year + 2).toString(),
								Periodicity: "Year",
								Compare: false,
							}
						})
					});
					this.simplePeriods = tempList; // Liste des périodes dans le formulaire
					this.setPeriod(); // Attribution de la période par défaut lors d'un changement de noeud
				}
				/** LISTE DES COMPTEURS */
				if("Meters" in data){
					this.meters = data["Meters"]; // Liste des compteurs
					this.configs.Data.Values = {}; // Initialisation des valeurs des compteurs
					this.meters.forEach((meter, index) => {
						Vue.set(this.configs.Data.Values, meter.PersistentId, []);
						this.meterNumberList.push(index + 1);
					});
					this.setMeterNumber(); // Initialisation du nombre de compteurs
					this.setAllValues(); // Initialisation des valeurs des compteurs
				}
				/** TITRE DE L'ETIQUETTE*/
				if("Title" in data)
					this.title = data["Title"]; // Titre de l'étiquette

				/** LISTE DES ERREURS */
				if("Errors" in data)
					this.localErrors = data["Errors"]; // Erreurs retournées par le serveur
			}
        }

		/** Attribut la période paramétré sinon prend une periode de la liste */
		private setPeriod(){
			if(this.simplePeriods.find(period => period.Id == this.configs.Period?.Start) != null){
				Vue.set(this.configs, 'Period', this.simplePeriods.find(period => period.Id == this.configs.Period.Start)?.Extras);
			} else if(this.simplePeriods.find(period => period.Extras.Duration == this.configs.Period?.Duration
				&& period.Extras.Periodicity == this.configs.Period?.Periodicity) != null){
				Vue.set(this.configs, 'Period', this.simplePeriods.find(period => period.Extras.Duration == this.configs.Period.Duration
				&& period.Extras.Periodicity == this.configs.Period.Periodicity)?.Extras);
			} else {
				if(this.simplePeriods.length > 2)
					Vue.set(this.configs, 'Period', this.simplePeriods.at(-3).Extras);
				else if(this.simplePeriods.length > 1)
					Vue.set(this.configs, 'Period', this.simplePeriods.at(-2).Extras);
				else if(this.simplePeriods.length > 0)
					Vue.set(this.configs, 'Period', this.simplePeriods.at(-1).Extras);
			}
		}

		//#endregion

		//#region Méthodes publiques

        /** Permet de vérifier la validité des différents champs obligatoires avant actualisation du résultat */
		public CheckInvalidity(): boolean {
			let result: boolean = false;
			if(this.configs.Data.Area == 0 && !this.Preview){
				this.errorList.push({ Message : this.$t('PleaseEnterASurface').toString() }); result = true; // 'Veuillez entrer une surface'
			}
			if(this.configs.Data.FactorId == 0){
				this.errorList.push({ Message : this.$t('PleaseSelectAFactor').toString()}); result = true; //  'Veuillez sélectionner un facteur d\'influence'
			}
			if(this.configs.Period == null){
				this.errorList.push({ Message : this.$t('PleaseSelectYear').toString() }); result = true; // 'Veuillez sélectionner une année'
			}
			if(this.configs.Data.Values == null){
				this.errorList.push({ Message : this.$t('PleaseSelectMeters').toString()}); result = true; // 'Veuillez sélectionner des compteurs'
			}

			return result;
		}

		/** Méthode GenerateTitle appelée dans le composant Config.vue
		 * pour la génération du titre */
		 public GenerateTitle(): string {
			return this.title;
		}

		/** Traitement des informations des pins sur changement */
		public async ProcessPin() {
			if(!this.Preview)
				await this.getNodeInformations(this.configs.Pins[0]).then((data) => this.initParameters(data));
		}

		//#endregion

		//#region Méthodes composant

        /** 
         * Pointeur vers fonction pour désactiver watcher sur l'instance de FilterTree () sur le noeud ou les pins sélectionnés 
         * @see https://vuejs.org/guide/essentials/watchers#stopping-a-watcher
         **/
		private unwatch = undefined;

		async mounted() {
			console.debug('OfficialLabels - created !!!');

			// TODO : Masquage du composant masque en attendant que la fonction OfficialLabels soit terminée
			this.$emit("HandleMaskEvent", false); // Masquage du composant Mask

			this.unwatch = this.$watch('configs.Period.Type', async (newVal, oldVal) => {
				if(newVal != oldVal){
					this.setPeriod();
				}
            });

			if(!this.Preview)
				await this.getNodeInformations(this.configs.Pins[0]).then((data) => this.initParameters(data));
			else
				await this.getPreviewInformations(this.ObjectType).then((data) => this.initParameters(data)).then(() => {
					this.setPeriod()
				});
		}

        beforeDestroy() {
			this.$emit("HandleMaskEvent", true); // Masquage du composant Mask
            // Libération watchers
            if (this.unwatch)
                this.unwatch();
        }

		//#endregion
    }

</script>

<style scoped lang="scss">

</style>